import { useTranslation } from 'react-i18next';

export function MultiTabWarning() {
  const { t } = useTranslation();
  const handleCloseTab = () => {
    if (window.opener) {
      window.close();
    } else {
      alert(t('multiTab.alertMessage'));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 text-center">
        {/* Optional icon */}
        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
          <span className="text-blue-600 text-xl font-bold">!</span>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {t('multiTab.warning')}
        </h2>

        <p className="text-gray-600 text-sm mb-6">
          {t('multiTab.message')}
          <br />
        </p>

        <button
          onClick={handleCloseTab}
          className="w-full rounded-lg bg-blue-600 hover:bg-blue-700 text-white py-2 font-medium transition"
        >
          {t('multiTab.button')}
        </button>

        <p className="mt-4 text-xs text-gray-400">{t('multiTab.warning2')}</p>
      </div>
    </div>
  );
}
